export const translations = {
  en: {
    nav: {
      about: "About",
      services: "Services",
      fleet: "Fleet",
      sales: "Aircraft Sales",
      contact: "Contact",
      cta: "Get a Quote",
    },
    whatsapp: "Chat with us on WhatsApp",
    hero: {
      overline: "Commercial Aircraft Maintenance · Lincoln, Nebraska",
      lines: ["WE KEEP", "AIRCRAFT", "FLYING."],
      sub: "Technical and maintenance services for commercial aircraft — plus aircraft sales & acquisition — delivered by a highly qualified, certified team.",
      ctaPrimary: "Explore Services",
      ctaSecondary: "Contact Us",
      stats: [
        { value: "24/7", label: "AOG Response" },
        { value: "20+", label: "Aircraft Types Certified" },
        { value: "100%", label: "Certified Personnel" },
      ],
      scroll: "Scroll",
    },
    marquee: [
      "LINE MAINTENANCE", "AOG RESPONSE 24/7", "RETURN TO SERVICE", "BOEING", "AIRBUS", "EMBRAER",
      "BOMBARDIER", "CESSNA", "CASA", "ENGINE CHANGE", "AVIONICS", "LANDING GEAR",
    ],
    about: {
      overline: "WHO WE ARE",
      title: "Safe and efficient processes at the highest standards of the aviation industry.",
      body: "LAJA AIR TECH SERVICES LLC is engaged in the provision of technical and maintenance services for commercial aircraft, and the sale and acquisition of aircraft. Our team is highly qualified and certified, allowing us to guarantee safe and efficient processes that comply with the highest standards of the aviation industry.",
      body2: "From routine line checks to AOG emergencies, our certified technicians cover Boeing, Airbus, Bombardier, Embraer, Cessna and CASA fleets. We are a fully mobile operation: we deploy our team and equipment wherever your aircraft is — your airport, your ramp, anywhere it is required.",
      points: ["Highly qualified & certified team", "Highest aviation industry standards", "Safe and efficient processes", "Mobile service — we come to you, anywhere"],
      ownerLabel: "Meet the Owner",
    },
    gallery: {
      overline: "OUR TEAM IN ACTION",
      title: "Real work. Real people. Real aircraft.",
      captions: ["Engine change operation", "Engine intake inspection", "Engine shop work", "Ramp & tail section service", "Cracked component found during inspection"],
    },
    services: {
      overline: "WHAT WE DO",
      title: "Full-spectrum aircraft maintenance capability.",
      sub: "Specialized service lines covering the entire aircraft — nose to tail, line to heavy check.",
      items: [
        { title: "Line Maintenance", desc: "Pre-flight and post-flight inspections, line transit maintenance, unscheduled maintenance and rapid AOG response.", tags: ["Pre/Post-flight", "Transit", "AOG"] },
        { title: "Major Maintenance & Scheduled Inspections", desc: "Major inspections as required by the manufacturer, with component overhaul through trusted third-party contracting.", tags: ["Major inspections", "Overhaul"] },
        { title: "Airframe Structures", desc: "Fuselage repair, wing and flight control surface repair, and advanced composite work.", tags: ["Fuselage", "Wings", "Composites"] },
        { title: "Aircraft Systems", desc: "Complete systems service: hydraulic, pneumatic, fuel, air conditioning and pressurization — including engine maintenance, inspection, engine changes and run-up tests, plus landing gear inspection, repair, replacement, brakes and tires.", tags: ["Hydraulic", "Pneumatic", "Fuel", "A/C", "Engines", "Landing Gear"] },
        { title: "Interiors", desc: "Aircraft interior removal and installation, executed with precision and care.", tags: ["Removal", "Installation"] },
        { title: "Avionics", desc: "Avionics equipment installation, removal and testing.", tags: ["Installation", "Testing"] },
        { title: "Return to Service (RTS)", desc: "Final inspection, documentation review and return-to-service release — certifying your aircraft is airworthy and ready to fly.", tags: ["RTS release", "Documentation", "Airworthiness"] },
        { title: "Additional Services", desc: "MODs, ADs and SBs compliance, aircraft weight & balance, technical advisory, maintenance consulting, and parts & components management (sales/supply).", tags: ["MODs / ADs / SBs", "Weight & Balance", "Consulting", "Parts supply"] },
      ],
    },
    ccheck: {
      overline: "UNDERSTANDING MAINTENANCE",
      title: "What exactly is a C Check?",
      body: "A C Check is a deep, scheduled inspection performed roughly every 18–24 months. The aircraft comes out of service for days or even weeks while technicians open panels and inspect the structure, systems, landing gear, avionics and hydraulics — work that can take up to 6,000 man-hours. It is the level of precision we bring to every job.",
      stats: ["Every 18–24 months", "Days to weeks in hangar", "Up to 6,000 man-hours"],
      videoLabel: "Video: C Check — AircraftVR",
    },
    fleet: {
      overline: "CERTIFIED EXPERTISE",
      title: "The fleets we are qualified and certified to serve.",
      groups: [
        { maker: "Boeing", models: ["727", "737 Series", "757", "767", "777", "787"] },
        { maker: "Airbus", models: ["A319", "A320 Series", "A300", "A340", "ATR 42", "ATR 72"] },
        { maker: "Bombardier", models: ["CRJ200", "CRJ700"] },
        { maker: "Embraer", models: ["EMB 145", "175", "190", "E2"] },
        { maker: "Cessna", models: ["208", "208B"] },
        { maker: "CASA", models: ["C235", "C295"] },
      ],
    },
    manifesto: {
      overline: "WHY LAJA",
      title: "Built on three commitments.",
      chapters: [
        { num: "01", title: "Safety without compromise", body: "Every inspection, every repair, every sign-off follows the highest standards of the aviation industry. No shortcuts — ever." },
        { num: "02", title: "Certified multi-fleet expertise", body: "Our personnel is qualified and certified across Boeing, Airbus, Embraer, Cessna and CASA aircraft — one team for your entire operation." },
        { num: "03", title: "Rapid AOG response", body: "When an aircraft is on the ground, every minute costs. Our AOG response gets you back in the air fast, anywhere." },
      ],
    },
    sales: {
      overline: "AIRCRAFT SALES & ACQUISITION",
      title: "Buy or sell aircraft with a technical team on your side.",
      body: "Beyond maintenance, we support the sale and acquisition of aircraft — with the technical insight to evaluate, inspect and advise at every step of the transaction.",
      cta: "Start a Conversation",
    },
    quote: {
      overline: "REQUEST A QUOTE",
      title: "Tell us what you need. We'll quote it.",
      body: "Share your aircraft, the service required and the location — our team will come back with a tailored quote, fast.",
      aogTitle: "AOG Emergency?",
      aogBody: "Call our 24/7 line for immediate dispatch.",
      form: {
        name: "Full name *",
        email: "Email address *",
        phone: "Phone",
        company: "Company",
        service: "Select a service *",
        other: "Other / Not sure",
        aircraft: "Aircraft type (e.g. Boeing 737-800)",
        location: "Location / Airport (e.g. KLNK, Lincoln NE)",
        message: "Describe what you need... *",
        submit: "Request Quote",
        sending: "Sending...",
        success: "Quote request received. We'll get back to you shortly.",
        error: "Something went wrong. Please try again or reach us on WhatsApp.",
      },
    },
    faq: {
      overline: "FAQ",
      title: "Common questions, straight answers.",
      items: [
        { q: "Do you have your own hangar?", a: "Not currently — we are a fully mobile operation. We bring our certified team and tooling to your airport or facility, wherever the aircraft is." },
        { q: "How fast can you respond to an AOG?", a: "We offer 24/7 AOG response. Call 402-217-5919 and we will dispatch a team as quickly as possible, anywhere." },
        { q: "Which aircraft are you certified on?", a: "Boeing 727/737/757/767/777/787, Airbus A319/A320/A300/A340 and ATR 42/72, Bombardier CRJ200/CRJ700, Embraer EMB 145/175/190/E2, Cessna 208/208B and CASA C235/C295." },
        { q: "Do you supply parts and components?", a: "Yes — we handle parts and components management (sales and supply), and we also support aircraft sales and acquisition." },
        { q: "How do I get a quote?", a: "Use the quote form on this page or message us on WhatsApp. Share the aircraft type, service needed and location, and we will respond promptly." },
      ],
    },
    contact: {
      overline: "GET IN TOUCH",
      title: "Let's keep your fleet flying.",
      body: "We remain fully available to provide additional information about our services and to explore opportunities for collaboration.",
      infoTitle: "Contact Information",
      owner: "Axel Garcia",
      role: "Owner / CEO",
      form: {
        name: "Full name",
        email: "Email address",
        company: "Company (optional)",
        message: "Tell us about your aircraft or operation...",
        submit: "Send Message",
        sending: "Sending...",
        success: "Message sent. We'll get back to you shortly.",
        error: "Something went wrong. Please try again or email us directly.",
      },
    },
    footer: {
      tagline: "Technical & maintenance services for commercial aircraft. Lincoln, Nebraska — USA.",
      rights: "All rights reserved.",
    },
  },
  es: {
    nav: {
      about: "Nosotros",
      services: "Servicios",
      fleet: "Flota",
      sales: "Venta de Aeronaves",
      contact: "Contacto",
      cta: "Solicitar Cotización",
    },
    whatsapp: "Escríbenos por WhatsApp",
    hero: {
      overline: "Mantenimiento de Aeronaves Comerciales · Lincoln, Nebraska",
      lines: ["MANTENEMOS", "AERONAVES", "VOLANDO."],
      sub: "Servicios técnicos y de mantenimiento para aeronaves comerciales — además de compra y venta de aeronaves — realizados por un equipo altamente calificado y certificado.",
      ctaPrimary: "Explorar Servicios",
      ctaSecondary: "Contáctanos",
      stats: [
        { value: "24/7", label: "Respuesta AOG" },
        { value: "20+", label: "Tipos de Aeronaves Certificados" },
        { value: "100%", label: "Personal Certificado" },
      ],
      scroll: "Desliza",
    },
    marquee: [
      "MANTENIMIENTO EN LÍNEA", "RESPUESTA AOG 24/7", "RETORNO AL SERVICIO", "BOEING", "AIRBUS", "EMBRAER",
      "BOMBARDIER", "CESSNA", "CASA", "CAMBIO DE MOTOR", "AVIÓNICA", "TREN DE ATERRIZAJE",
    ],
    about: {
      overline: "QUIÉNES SOMOS",
      title: "Procesos seguros y eficientes bajo los más altos estándares de la industria aeronáutica.",
      body: "LAJA AIR TECH SERVICES LLC se dedica a la prestación de servicios técnicos y de mantenimiento para aeronaves comerciales, así como a la compra y venta de aeronaves. Nuestro equipo está altamente calificado y certificado, lo que nos permite garantizar procesos seguros y eficientes que cumplen con los más altos estándares de la industria de la aviación.",
      body2: "Desde inspecciones de línea de rutina hasta emergencias AOG, nuestros técnicos certificados cubren flotas Boeing, Airbus, Bombardier, Embraer, Cessna y CASA. Somos una operación totalmente móvil: llevamos nuestro equipo y personal a donde esté tu aeronave — tu aeropuerto, tu plataforma, cualquier lugar que lo requieras.",
      points: ["Equipo altamente calificado y certificado", "Los más altos estándares de la industria", "Procesos seguros y eficientes", "Servicio móvil — vamos a donde nos necesites"],
      ownerLabel: "Conoce al Propietario",
    },
    gallery: {
      overline: "NUESTRO EQUIPO EN ACCIÓN",
      title: "Trabajo real. Gente real. Aeronaves reales.",
      captions: ["Operación de cambio de motor", "Inspección de admisión de motor", "Trabajo de motor en taller", "Servicio de rampa y sección de cola", "Componente quebrado encontrado durante inspección"],
    },
    services: {
      overline: "NUESTROS SERVICIOS",
      title: "Capacidad integral de mantenimiento aeronáutico.",
      sub: "Líneas de servicio especializadas que cubren toda la aeronave — de nariz a cola, de línea a inspección mayor.",
      items: [
        { title: "Mantenimiento en Línea", desc: "Inspecciones pre-vuelo y post-vuelo, mantenimiento de tránsito en línea, mantenimiento no programado y respuesta rápida AOG.", tags: ["Pre/Post-vuelo", "Tránsito", "AOG"] },
        { title: "Mantenimiento Mayor e Inspecciones Programadas", desc: "Inspecciones mayores según lo requerido por el fabricante, con overhaul de componentes a través de terceros certificados.", tags: ["Inspecciones mayores", "Overhaul"] },
        { title: "Estructuras (Fuselaje)", desc: "Reparación de fuselaje, alas y superficies de control de vuelo, y trabajo avanzado en compuestos.", tags: ["Fuselaje", "Alas", "Compuestos"] },
        { title: "Sistemas de Aeronaves", desc: "Servicio completo de sistemas: hidráulico, neumático, combustible, aire acondicionado y presurización — incluyendo mantenimiento, inspección, cambio de motores y pruebas run-up, además de inspección, reparación y reemplazo del tren de aterrizaje, frenos y llantas.", tags: ["Hidráulico", "Neumático", "Combustible", "A/C", "Motores", "Tren de Aterrizaje"] },
        { title: "Interiores", desc: "Remoción e instalación de interiores de aeronaves, ejecutada con precisión y cuidado.", tags: ["Remoción", "Instalación"] },
        { title: "Aviónica", desc: "Instalación, remoción y pruebas de equipos de aviónica.", tags: ["Instalación", "Pruebas"] },
        { title: "Retorno al Servicio (RTS)", desc: "Inspección final, revisión de documentación y liberación de retorno al servicio — certificando que tu aeronave está en condiciones de volar.", tags: ["Liberación RTS", "Documentación", "Aeronavegabilidad"] },
        { title: "Servicios Adicionales", desc: "Cumplimiento de MODs, ADs y SBs, peso y balance de aeronaves, asesoría técnica, consultoría de mantenimiento y gestión de partes y componentes (venta/suministro).", tags: ["MODs / ADs / SBs", "Peso y Balance", "Consultoría", "Suministro de partes"] },
      ],
    },
    ccheck: {
      overline: "ENTENDIENDO EL MANTENIMIENTO",
      title: "¿Qué es exactamente un C Check?",
      body: "Un C Check es una inspección profunda y programada que se realiza aproximadamente cada 18–24 meses. La aeronave sale de servicio durante días o incluso semanas mientras los técnicos abren paneles e inspeccionan la estructura, sistemas, tren de aterrizaje, aviónica e hidráulica — un trabajo que puede tomar hasta 6,000 horas-hombre. Ese es el nivel de precisión que llevamos a cada trabajo.",
      stats: ["Cada 18–24 meses", "Días a semanas en hangar", "Hasta 6,000 horas-hombre"],
      videoLabel: "Video: C Check — AircraftVR",
    },
    fleet: {
      overline: "EXPERIENCIA CERTIFICADA",
      title: "Las flotas que estamos calificados y certificados para atender.",
      groups: [
        { maker: "Boeing", models: ["727", "737 Series", "757", "767", "777", "787"] },
        { maker: "Airbus", models: ["A319", "A320 Series", "A300", "A340", "ATR 42", "ATR 72"] },
        { maker: "Bombardier", models: ["CRJ200", "CRJ700"] },
        { maker: "Embraer", models: ["EMB 145", "175", "190", "E2"] },
        { maker: "Cessna", models: ["208", "208B"] },
        { maker: "CASA", models: ["C235", "C295"] },
      ],
    },
    manifesto: {
      overline: "POR QUÉ LAJA",
      title: "Construidos sobre tres compromisos.",
      chapters: [
        { num: "01", title: "Seguridad sin concesiones", body: "Cada inspección, cada reparación, cada firma sigue los más altos estándares de la industria aeronáutica. Sin atajos — nunca." },
        { num: "02", title: "Experiencia certificada multi-flota", body: "Nuestro personal está calificado y certificado en aeronaves Boeing, Airbus, Embraer, Cessna y CASA — un solo equipo para toda tu operación." },
        { num: "03", title: "Respuesta rápida AOG", body: "Cuando una aeronave está en tierra, cada minuto cuesta. Nuestra respuesta AOG te devuelve al aire rápidamente, en cualquier lugar." },
      ],
    },
    sales: {
      overline: "COMPRA Y VENTA DE AERONAVES",
      title: "Compra o vende aeronaves con un equipo técnico a tu lado.",
      body: "Más allá del mantenimiento, apoyamos la compra y venta de aeronaves — con el conocimiento técnico para evaluar, inspeccionar y asesorar en cada paso de la transacción.",
      cta: "Iniciar una Conversación",
    },
    quote: {
      overline: "SOLICITA UNA COTIZACIÓN",
      title: "Cuéntanos qué necesitas. Te lo cotizamos.",
      body: "Comparte tu aeronave, el servicio requerido y la ubicación — nuestro equipo responderá con una cotización a tu medida, rápido.",
      aogTitle: "¿Emergencia AOG?",
      aogBody: "Llama a nuestra línea 24/7 para despacho inmediato.",
      form: {
        name: "Nombre completo *",
        email: "Correo electrónico *",
        phone: "Teléfono",
        company: "Empresa",
        service: "Selecciona un servicio *",
        other: "Otro / No estoy seguro",
        aircraft: "Tipo de aeronave (ej. Boeing 737-800)",
        location: "Ubicación / Aeropuerto (ej. KLNK, Lincoln NE)",
        message: "Describe lo que necesitas... *",
        submit: "Solicitar Cotización",
        sending: "Enviando...",
        success: "Cotización recibida. Te responderemos pronto.",
        error: "Algo salió mal. Inténtalo de nuevo o escríbenos por WhatsApp.",
      },
    },
    faq: {
      overline: "PREGUNTAS FRECUENTES",
      title: "Preguntas comunes, respuestas directas.",
      items: [
        { q: "¿Tienen hangar propio?", a: "Actualmente no — somos una operación totalmente móvil. Llevamos nuestro equipo certificado y herramientas a tu aeropuerto o instalación, donde esté la aeronave." },
        { q: "¿Qué tan rápido responden a un AOG?", a: "Ofrecemos respuesta AOG 24/7. Llama al 402-217-5919 y despacharemos un equipo lo más rápido posible, a cualquier lugar." },
        { q: "¿En qué aeronaves están certificados?", a: "Boeing 727/737/757/767/777/787, Airbus A319/A320/A300/A340 y ATR 42/72, Bombardier CRJ200/CRJ700, Embraer EMB 145/175/190/E2, Cessna 208/208B y CASA C235/C295." },
        { q: "¿Suministran partes y componentes?", a: "Sí — gestionamos partes y componentes (venta y suministro), y también apoyamos la compra y venta de aeronaves." },
        { q: "¿Cómo obtengo una cotización?", a: "Usa el formulario de cotización en esta página o escríbenos por WhatsApp. Comparte el tipo de aeronave, el servicio y la ubicación, y te responderemos pronto." },
      ],
    },
    contact: {
      overline: "CONTÁCTANOS",
      title: "Mantengamos tu flota en el aire.",
      body: "Permanecemos completamente disponibles para brindarte información adicional sobre nuestros servicios y explorar oportunidades de colaboración.",
      infoTitle: "Información de Contacto",
      owner: "Axel Garcia",
      role: "Propietario / CEO",
      form: {
        name: "Nombre completo",
        email: "Correo electrónico",
        company: "Empresa (opcional)",
        message: "Cuéntanos sobre tu aeronave u operación...",
        submit: "Enviar Mensaje",
        sending: "Enviando...",
        success: "Mensaje enviado. Te responderemos pronto.",
        error: "Algo salió mal. Inténtalo de nuevo o escríbenos directamente.",
      },
    },
    footer: {
      tagline: "Servicios técnicos y de mantenimiento para aeronaves comerciales. Lincoln, Nebraska — EE. UU.",
      rights: "Todos los derechos reservados.",
    },
  },
};

export const CONTACT = {
  email: "agarcia@lajaairtech.net",
  phone: "402-217-5919",
  phoneHref: "+14022175919",
  address: "1224 S 21st St, Lincoln NE 68502",
};
